var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{key:_vm.currentComponent,attrs:{"name":"fade"}},[(_vm.currentComponent === 'mini')?_c('TariffMiniBurn',{on:{"setCurrentComponent":_vm.setCurrentComponent}}):_c('TariffFullBurn',{on:{"setCurrentComponent":_vm.setCurrentComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }